import React, { useState } from 'react'
import "./Header.css"
import {Link} from "react-router-dom"


const Header = () => {
    const [active, setActive] = useState(false)

  return (
    <div className="header">
        <div className="header__head">
            <Link to="/">
                <div className="header__title">
                    Portfolio
                </div>
            </Link>
        </div>

        
        <div  className="nav">
            <nav className={active ? "menu-nav open" : "menu-nav closed"}>
                <Link to="/" onClick={() => setActive(!active)}>
                    <div className="header__navitem" >
                        Home
                    </div>
                </Link>
                <a smooth href="/#about" onClick={() => setActive(!active)}>
                    <div className="header__navitem">
                        About
                    </div>
                </a>
                <a href="/#projects" onClick={() => setActive(!active)}>
                    <div className="header__navitem">
                        Projects
                    </div>
                </a>
                <a href="/#skills" onClick={() => setActive(!active)}>
                    <div className="header__navitem">
                        Skills
                    </div>
                </a>
               
                <a href="/#contact" onClick={() => setActive(!active)}>
                    <div className="header__navitem">
                        Contact
                    </div>
                </a>
            </nav>
           

            <div className="menu-btn" onClick={() => setActive(!active)}>
                    <span className={active ? "menu-btn__burger open" : "menu-btn__burger"}>
                     
                    </span>
            </div>

            
        
        </div>

    </div>
  )
}

export default Header